


























import { Component, Prop, Vue } from 'vue-property-decorator'
import FormField from '@/utilities/validation/formfield'

@Component
export default class VInput extends Vue {
  @Prop({ default: 'text' }) private type!: string;
  @Prop({ default: '' }) private label!: string;
  @Prop({ required: true }) private field!: FormField;
  @Prop() private placeholder!: string;
  @Prop({ default: false }) private disabled!: boolean;

  get valid () {
    return this.field.validate()
  }

  get validClass () {
    return this.valid === null ? '' : this.valid.length === 0 && this.field.serverError === null ? 'valid' : 'invalid'
  }

  private updateField () {
    const newField = this.field
    newField.value = this.field.value
    this.$emit('update:field', newField)
  }

  private setDirty () {
    const newField = this.field
    newField.dirty = true
    this.$emit('update:field', newField)
  }
}
